<template>
    <button class="btn" v-bind:class="'btn-' + type" v-on:click="$emit('click')">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: "CircleButton",

        props: {
            type: {
                type: String,
                default: 'primary'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn {
        @include shadow;

        border-radius: 100px;
        padding: 0;
        width: 33px;
        height: 33px;
        line-height: 12px;
    }
</style>